// Router. Routes that need auth go through <RequireAuth>. /login is public.

import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './auth.js';
import { Layout } from './components/layout.js';
import { RequireAuth } from './components/require-auth.js';
import { LoginPage } from './pages/login.js';
import { SignupPage } from './pages/signup.js';
import { VerifyEmailPage } from './pages/verify-email.js';
import { ForgotPasswordPage } from './pages/forgot-password.js';
import { ResetPasswordPage } from './pages/reset-password.js';
import { ProjectsListPage } from './pages/projects-list.js';
import { NewProjectPage } from './pages/new-project.js';
import { ProjectPage } from './pages/project.js';
import { SettingsPage } from './pages/settings.js';
import { VoiceClonesPage } from './pages/voice-clones.js';
import { BatchPage } from './pages/batch.js';
import { BatchDetailPage } from './pages/batch-detail.js';
import { PromptsPage } from './pages/prompts.js';
import { AnalyticsPage } from './pages/analytics.js';
import { ApiKeysPage } from './pages/api-keys.js';

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/login" element={<LoginPage />} />
            <Route path="/signup" element={<SignupPage />} />
            <Route path="/verify-email" element={<VerifyEmailPage />} />
            <Route path="/forgot-password" element={<ForgotPasswordPage />} />
            <Route path="/reset-password" element={<ResetPasswordPage />} />
            <Route
              path="/"
              element={<Navigate to="/projects" replace />}
            />
            <Route
              path="/projects"
              element={<RequireAuth><ProjectsListPage /></RequireAuth>}
            />
            <Route
              path="/projects/new"
              element={<RequireAuth><NewProjectPage /></RequireAuth>}
            />
            <Route
              path="/projects/:id"
              element={<RequireAuth><ProjectPage /></RequireAuth>}
            />
            <Route
              path="/settings"
              element={<RequireAuth><SettingsPage /></RequireAuth>}
            />
            <Route
              path="/voice-clones"
              element={<RequireAuth><VoiceClonesPage /></RequireAuth>}
            />
            <Route
              path="/batch"
              element={<RequireAuth><BatchPage /></RequireAuth>}
            />
            <Route
              path="/batch/:id"
              element={<RequireAuth><BatchDetailPage /></RequireAuth>}
            />
            <Route
              path="/prompts"
              element={<RequireAuth><PromptsPage /></RequireAuth>}
            />
            <Route
              path="/analytics"
              element={<RequireAuth><AnalyticsPage /></RequireAuth>}
            />
            <Route
              path="/api-keys"
              element={<RequireAuth><ApiKeysPage /></RequireAuth>}
            />
            <Route path="*" element={<NotFound />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

function NotFound() {
  return (
    <div className="text-center py-24">
      <h1 className="font-serif text-3xl mb-2">Page not found</h1>
      <p className="text-muted text-sm">Try the projects list.</p>
    </div>
  );
}
